import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FocusVisibleBoxShadow from './FocusVisibleBoxShadow';
import ClientProvider from './client';
export default createDemo(import.meta.url, FocusVisibleBoxShadow, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/focus-visible/demos/box-shadow/FocusVisibleBoxShadow.tsx",
    "fileName": "FocusVisibleBoxShadow.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Stack from '@mui/material/Stack';\nimport Card from '@mui/material/Card';\nimport AppBar from '@mui/material/AppBar';\nimport Toolbar from '@mui/material/Toolbar';\nimport Typography from '@mui/material/Typography';\nimport Button from '@mui/material/Button';\nimport Tabs from '@mui/material/Tabs';\nimport Tab from '@mui/material/Tab';\n\nconst theme = createTheme({\n  focusVisible: {\n    /* inner indicator */\n    outlineColor: '#193146',\n    outlineOffset: 2,\n    /* outer indicator */\n    boxShadow: '0 0 0 4px #FFF',\n  },\n  colorSchemes: { light: true, dark: true },\n  // These demos opt out of the ripple, so the focus ring is the only keyboard indicator.\n  components: { MuiButtonBase: { defaultProps: { disableRipple: true } } },\n});\n\nexport default function FocusVisibleBoxShadow() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 1,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [cardTab, setCardTab] = React.useState(0);\n  const [appBarTab, setAppBarTab] = React.useState(0);\n  const handleCardChange = (event: React.SyntheticEvent, newValue: number) => {\n    setCardTab(newValue);\n  };\n  const handleAppBarChange = (event: React.SyntheticEvent, newValue: number) => {\n    setAppBarTab(newValue);\n  };\n  return (\n    <ThemeProvider theme={theme}>\n      <Stack spacing={2} sx={{ width: '100%' }}>\n        <Typography variant=\"body2\" color=\"text.secondary\">\n          Press <kbd>Tab</kbd> — the light outline or the dark box-shadow keeps\n          contrast on either background.\n        </Typography>\n        <Card\n          sx={{\n            px: 3,\n            minHeight: 64,\n            display: 'flex',\n            alignItems: 'center',\n            gap: 3,\n          }}\n        >\n          <Button variant=\"outlined\">Tab to me</Button>\n          <Tabs value={cardTab} onChange={handleCardChange}>\n            <Tab label=\"Tab one\" />\n            <Tab label=\"Tab two\" />\n          </Tabs>\n        </Card>\n        <AppBar position=\"static\" sx={{ borderRadius: 1 }}>\n          <Toolbar sx={{ gap: 3 }}>\n            <Button variant=\"outlined\" color=\"inherit\">\n              Tab to me\n            </Button>\n            <Tabs\n              value={appBarTab}\n              onChange={handleAppBarChange}\n              textColor=\"inherit\"\n              indicatorColor=\"secondary\"\n            >\n              <Tab label=\"Tab one\" />\n              <Tab label=\"Tab two\" />\n            </Tabs>\n          </Toolbar>\n        </AppBar>\n      </Stack>\n    </ThemeProvider>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 75,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Stack from '@mui/material/Stack';\nimport Card from '@mui/material/Card';\nimport AppBar from '@mui/material/AppBar';\nimport Toolbar from '@mui/material/Toolbar';\nimport Typography from '@mui/material/Typography';\nimport Button from '@mui/material/Button';\nimport Tabs from '@mui/material/Tabs';\nimport Tab from '@mui/material/Tab';\n\nconst theme = createTheme({\n  focusVisible: {\n    /* inner indicator */\n    outlineColor: '#193146',\n    outlineOffset: 2,\n    /* outer indicator */\n    boxShadow: '0 0 0 4px #FFF',\n  },\n  colorSchemes: { light: true, dark: true },\n  // These demos opt out of the ripple, so the focus ring is the only keyboard indicator.\n  components: { MuiButtonBase: { defaultProps: { disableRipple: true } } },\n});\n\nexport default function FocusVisibleBoxShadow() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 1
        },
        "  const [cardTab, setCardTab] = React.useState(0);\n  const [appBarTab, setAppBarTab] = React.useState(0);\n  const handleCardChange = (event: React.SyntheticEvent, newValue: number) => {\n    setCardTab(newValue);\n  };\n  const handleAppBarChange = (event: React.SyntheticEvent, newValue: number) => {\n    setAppBarTab(newValue);\n  };\n  return (\n    <ThemeProvider theme={theme}>\n      <Stack spacing={2} sx={{ width: '100%' }}>\n        <Typography variant=\"body2\" color=\"text.secondary\">\n          Press <kbd>Tab</kbd> — the light outline or the dark box-shadow keeps\n          contrast on either background.\n        </Typography>\n        <Card\n          sx={{\n            px: 3,\n            minHeight: 64,\n            display: 'flex',\n            alignItems: 'center',\n            gap: 3,\n          }}\n        >\n          <Button variant=\"outlined\">Tab to me</Button>\n          <Tabs value={cardTab} onChange={handleCardChange}>\n            <Tab label=\"Tab one\" />\n            <Tab label=\"Tab two\" />\n          </Tabs>\n        </Card>\n        <AppBar position=\"static\" sx={{ borderRadius: 1 }}>\n          <Toolbar sx={{ gap: 3 }}>\n            <Button variant=\"outlined\" color=\"inherit\">\n              Tab to me\n            </Button>\n            <Tabs\n              value={appBarTab}\n              onChange={handleAppBarChange}\n              textColor=\"inherit\"\n              indicatorColor=\"secondary\"\n            >\n              <Tab label=\"Tab one\" />\n              <Tab label=\"Tab two\" />\n            </Tabs>\n          </Toolbar>\n        </AppBar>\n      </Stack>\n    </ThemeProvider>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 75,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Stack",
      "@mui/material/Card",
      "@mui/material/AppBar",
      "@mui/material/Toolbar",
      "@mui/material/Typography",
      "@mui/material/Button",
      "@mui/material/Tabs",
      "@mui/material/Tab"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
